export default "__VITE_ASSET__DSKyQcuK__"